import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'checkbox-item',
    templateUrl: './checkbox-item.component.html',
    styleUrls: ['../checkbox-treeview/checkbox-treeview.component.scss']
})
export class CheckboxItemComponent {
    @Input() text: string;
    @Input() value: string;
    @Input() checked: boolean;
    @Output() clicked = new EventEmitter();

    public onClick(): void {
        this.checked = !this.checked;
        this.clicked.emit(this.checked);
    }
}